import clsx from 'clsx';

import type { ButtonProps } from './Button';
import s from './ButtonGhost.module.scss';

/**
 * The quiet third level: no fill and no border at rest, ink only, and a wash under the
 * pointer. For an action that has to be available without competing with the content it
 * sits on — an Edit on a card header, a row's own control, a way out of a section.
 *
 * It sizes to its own ink rather than to the button scale, which is what separates it
 * from `ButtonPill`: a pill is a control with a surface, this is a label you can press.
 */
const ButtonGhost = ({ type = 'button', className, ...props }: ButtonProps) => (
  <button type={type} className={clsx(s.ghost, className)} {...props} />
);

export default ButtonGhost;
